
import axios from "axios";
import queryString from "query-string";
import { toast } from "react-toastify";

// Constants
import { EMPTY_OBJECT } from "../constants/base.constants";
import { BASE_URL } from "../constants/services";
import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_NUMBER,
} from "../constants/pagination";

// Utils
import { getDataFromResponse } from "../utils";

const headers = {
  headers: {
    authorization: `Bearer ${window.localStorage.getItem("token")}`,
  }
}

const fetchPromotions = ({
  pageNumber = DEFAULT_PAGE_NUMBER,
  pageSize = DEFAULT_PAGE_SIZE,
  searchText = "",
  sortField,
  order,
  self
} = EMPTY_OBJECT) => {
  const payload = {
    page: pageNumber,
    limit: pageSize,
    search_text: searchText,
    sort_field: sortField,
    order_by: order === "descend" ? "desc" : order === "ascend" ? "asc" : "",
    self
  };
  const url = queryString.stringifyUrl({
    url: `${BASE_URL}/promotion`,
    query: payload,
  });
  return axios
    .get(url, headers)
    .then((response) => getDataFromResponse(response))
    .catch((error) => {
      toast.error(error.response.data?.error);
    });
};

const createPromotion = (payload = EMPTY_OBJECT) => {
  const url = queryString.stringifyUrl({
    url: `${BASE_URL}/promotion`,
  });
  return axios
    .post(url, payload, headers)
    .then((response) => response.data)
    .catch((error) => {
      toast.error(error.response.data?.error);
    });
};

const updatePromotion = (payload = EMPTY_OBJECT) => {
  const url = queryString.stringifyUrl({
    url: `${BASE_URL}/promotion`,
  });
  return axios
    .put(url, payload, headers)
    .then((response) => response.data)
    .catch((error) => {
      console.log(error.response.data, 'response')
      toast.error(error.response.data?.error);
    });
};

const deletePromotion = (id) => {
  const url = queryString.stringifyUrl({
    url: `${BASE_URL}/promotion/${id}`,
  });
  return axios
    .delete(url, headers)
    .then((response) => response.data)
    .catch((error) => {
      toast.error(error.response.data?.error);
    });
};

const checkCode = (payload = EMPTY_OBJECT) => {
  const url = queryString.stringifyUrl({
    url: `${BASE_URL}/promotion/checkcode`,
  });
  return axios
    .post(url, payload, headers)
    .then((response) => response.data)
    .catch((error) => {
      toast.error(error.response.data?.error);
    });
};

const checkUsedUser = (payload = EMPTY_OBJECT) => {
  const url = queryString.stringifyUrl({
    url: `${BASE_URL}/promotion/useduser`,
  });
  return axios
    .post(url, { promotion_id: payload }, headers)
    .then((response) => response.data)
    .catch((error) => {
      toast.error(error.response.data?.error);
    });
};

export default {
  fetchPromotions,
  createPromotion,
  updatePromotion,
  deletePromotion,
  checkCode,
  checkUsedUser,
};
